import script from "./HeadMeta.vue?vue&type=script&lang=js"
export * from "./HeadMeta.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__